<h2 class="mat-h2" matDialogTitle>Archive Ad(s)</h2>

<mat-dialog-content>
  <mat-divider></mat-divider>
  <p class="mat-body-2">Archiving an Ad campaign prevents new affiliates from picking up the ad.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" class="white" [matDialogClose]="false">Cancel</button>
  <button mat-raised-button color="primary" [matDialogClose]="true">Archive</button>
</mat-dialog-actions>
